import { render } from "./Salesreps.vue?vue&type=template&id=2184ef8f&scoped=true"
import script from "./Salesreps.vue?vue&type=script&lang=js"
export * from "./Salesreps.vue?vue&type=script&lang=js"

import "./Salesreps.vue?vue&type=style&index=0&id=2184ef8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2184ef8f"]])

export default __exports__